import { render, staticRenderFns } from "./orderManage.vue?vue&type=template&id=a6b716b6&scoped=true&"
import script from "./orderManage.vue?vue&type=script&lang=js&"
export * from "./orderManage.vue?vue&type=script&lang=js&"
import style0 from "./orderManage.vue?vue&type=style&index=0&id=a6b716b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b716b6",
  null
  
)

export default component.exports